import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ProfilePanel } from "@/components/portal/ProfilePanel";
import { LanguageSelector } from "@/components/portal/LanguageSelector";
import { PortalMessagesButton } from "./PortalMessages";
import logo from "@/assets/logo-thailand-elite.png";

// White label mode: set VITE_WHITE_LABEL=true in env to hide branding
const WHITE_LABEL = import.meta.env.VITE_WHITE_LABEL === "true";

interface PortalHeaderProps {
  backTo?: string;
  backLabel?: string;
}

export const PortalHeader = ({
  backTo = "/portal/dashboard",
  backLabel = "Dashboard",
}: PortalHeaderProps) => {
  const navigate = useNavigate();
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-b border-border h-14">
      <div className="container mx-auto px-4 flex items-center justify-between h-full max-w-5xl">

        {/* Left: back + logo */}
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate(backTo)}
            className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors group"
          >
            <ArrowLeft className="h-4 w-4 group-hover:-translate-x-0.5 transition-transform" />
            <span className="hidden sm:inline">{backLabel}</span>
          </button>

          {!WHITE_LABEL && (
            <img
              src={logo}
              alt="Thailand Elite"
              className="h-7 opacity-80"
            />
          )}
        </div>

        {/* Right: language + support chat + profile */}
        <div className="flex items-center gap-1">
          <LanguageSelector compact />
          <PortalMessagesButton />
          <ProfilePanel />
        </div>
      </div>
    </header>
  );
};
